export type MessageType = 'error' | 'warning' | 'confirmation' | 'info' | 'success';

export function messageType(value: string): MessageType {
  switch ((value || '').toLowerCase()) {
    case 'danger': case 'error': return 'error';
    case 'warning': return 'warning';
    case 'confirmation': return 'confirmation';
    case 'success': return 'success';
    default: return 'info';
  }
}

export function messageIcon(type: MessageType): string {
  return {error:'fa-exclamation-circle', warning:'fa-exclamation-triangle', confirmation:'fa-question-circle', info:'fa-info-circle', success:'fa-check-circle'}[type];
}
